<!-- Services -->
@if (quoteConfig()?.items?.dataList?.length) {
    <div class="card-base-design quote-container">
        
        <!-- Title -->
        <p class="ra-label-s content-secondary">{{ 'document.preview.quote.productsAndServices' | translate }}</p>

        <!-- Items -->
        @for (item of quoteConfig()?.items?.dataList; track item._id) {
            <div class="container-item">

                <!-- Name -->
                <p class="ra-label-l bold">{{ item?.name }}</p>

                <!-- Price -->
                <div class="container-item-value">
                    <p class="ra-label-s content-secondary">{{ 'document.preview.quote.pricePer' | translate }} {{ item?.unitOfMeasurement | unitOfMeasurementFormat }}</p>
                    <p class="ra-label-s content-secondary">{{ item?.unitPrice | raCurrency : currencyCode() : locale() }}</p>
                </div>
                
                <!-- Und -->
                <div class="container-item-value">
                    <p class="ra-label-s content-secondary">{{ 'document.preview.quote.unitAbbrev' | translate }}</p>
                    <p class="ra-label-s content-secondary">{{ item?.quantity }}</p>
                </div>
                
                <!-- Subtotal -->
                <div class="container-item-value">
                    <p class="ra-label-s content-secondary">{{ 'document.preview.quote.subtotal' | translate }}</p>
                    <p class="ra-label-s bold">{{ item?.unitPrice * item?.quantity | raCurrency : currencyCode() : locale() }}</p>
                </div>
            </div>
        }
    </div>
}

<!-- Taxes -->
@if (quoteConfig()?.taxes?.totalPrice) {
    <div class="card-base-design quote-container">
        
        <!-- Title -->
        <p class="ra-label-s content-secondary">{{ 'document.preview.quote.taxes' | translate }}</p>

        <!-- Items -->
        @for (item of quoteConfig()?.taxes?.dataList; track item._id) {
            <div class="container-item">

                <!-- Name -->
                <p class="ra-label-l bold">{{ item?.name }}</p>

                <!-- Value -->
                <div class="container-item-value">
                    <p class="ra-label-s content-secondary">{{ 'document.preview.quote.value' | translate }}</p>
                    <p class="ra-label-s bold">{{ item?.price | raCurrency : currencyCode() : locale() }}</p>
                </div>
            </div>
        }
    </div>
}

<!-- Totais -->
<div class="card-base-design quote-container">
    
    <!-- Title -->
    <p class="ra-label-l bold">{{ 'document.preview.quote.totals' | translate }}</p>

    <!-- Items -->
    <div class="container-item total-container">

        <!-- Produtos e serviços -->
        <div class="container-item-value">
            <p class="ra-label-s content-secondary">{{ 'document.preview.quote.productsAndServices' | translate }}</p>
            <p class="ra-label-s content-secondary">{{ quoteConfig().items?.totalPrice | raCurrency : currencyCode() : locale() }}</p>
        </div>
        
        <!-- Impostos e taxas -->
        @if (quoteConfig()?.taxes?.totalPrice) 
        {
            <div class="container-item-value">
                <p class="ra-label-s content-secondary">{{ 'document.preview.quote.taxes' | translate }}</p>
                <p class="ra-label-s content-secondary">{{ quoteConfig().taxes?.totalPrice | raCurrency : currencyCode() : locale() }}</p>
            </div>
        }
        
        <!-- Descontos -->
        @if (quoteConfig()?.discount?.value)
        {
            <div class="container-item-value">
                <p class="ra-label-s content-secondary">{{ 'document.preview.quote.discounts' | translate }}</p>
                @if (quoteConfig()?.discount?.mode === 'percentage') {
                    <p class="ra-label-s content-secondary">-{{ formatPercent(quoteConfig()?.discount?.value, locale()) }}</p>
                } @else {
                    <p class="ra-label-s content-secondary">-{{ quoteConfig()?.discount?.value | raCurrency : currencyCode() : locale() }}</p>
                }
            </div>
        }

        <!-- Subtotal -->
        <div class="container-item-value">
            <p class="ra-label-s content-secondary">{{ 'document.preview.quote.quoteTotal' | translate }}</p>
            <p class="ra-label-s bold">{{ quoteConfig()?.totalPrice | raCurrency : currencyCode() : locale() }}</p>
        </div>
    </div>
</div>
